import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, first } from 'rxjs/operators';
import { UserStorage } from '../user/user-storage';

@Component({
    selector: 'dashboard-container',
    template: require('./dashboard-container.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardContainerComponent implements OnInit {
    public isInvestigator$: Observable<boolean>;
    public isSponsor$: Observable<boolean>;
    public isAdminOrInternal$: Observable<boolean>;

    constructor(private userStorage: UserStorage) { }

    public ngOnInit() {
        const user = this.userStorage.currentUser.pipe(first());
        
        this.isInvestigator$ = user.pipe(map(u => u.isInvestigator));
        this.isSponsor$ = user.pipe(map(u => u.isSponsor));
        this.isAdminOrInternal$ = user.pipe(map(u => u.isAdmin || u.isSystemAdmin || u.isInternal));
    }
}
